import { MDBCol, MDBContainer, MDBRow, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import { shallow } from "zustand/shallow";
import { useSettingsStore } from "../../store/settingsStore";
import { useEffect, useState } from "react";
import moment, { months } from "moment"
import 'moment/locale/es'
import { formatMoney, formatPhone } from "../general/utils";
import styled from "@emotion/styled";

const StyledComponent = styled(MDBContainer)`
    padding: 0; 
    margin-bottom: "40px";
    font-size: 14px !important;
    & p {
        margin: 0;
        font-size: 14px !important;
    }
    & h6 {
        font-size: 14px !important;
    }
`

moment.locale('es')

interface IProps {
    printData: any;
}
const ComponentToPrint = ({ printData }: IProps) => {
    const clientesServer = useSettingsStore((state) => (state.clientes), shallow)
    const [client, setClient] = useState<any>(null)
    const user = { name: "Maria Jimenez", correo: "maria.jiminez@a.com", telefono: "6623296572" } // useState()
    const today = moment()
// console.log("printData >> ", printData)
    const headers = [
        { label: "Cantidad", name: "cantidadRequisicion" },
        { label: "Repeticion", name: "repeticion" },
        { label: "Costo Requisicion", name: "costoRequisicion" },
        { 
            label: "Total", 
            name: "Total",
            customItem: (row: { cantidadRequisicion: any, repeticion: any, costoRequisicion: any }) => formatMoney( Number(row.cantidadRequisicion * Number(row.repeticion) * Number(row.costoRequisicion))) ,
        },
    ]

    useEffect(() => {
        const clientData = clientesServer.find(({uid}) => uid === printData?.cliente)
        setClient(clientData )
    }, [clientesServer, printData?.cliente])

    const showItem = (items: any) => {
        return (
            <MDBTable>
                <MDBTableHead key="tb-products">
                    <tr>
                    { headers.map(({label, name}) => {
                        return <th key={`tb-products-th-${name}`} scope='col'>{ label }</th>
                    }) }
                    <th></th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    {
                    items.map((item: any, index: number) => {
                        return (
                        <tr key={`products-tr-${index}`} >
                            { headers.map(({name, customItem}) => {
                            return <td key={`products-td-${name}`} >{ customItem ? customItem(item) : item[name] }</td>
                            })}
                    
                        </tr>
                        )
                    })
                    }
                </MDBTableBody>
            </MDBTable> 
        )
    }

    return (
        <StyledComponent >
            <MDBRow style={{ textAlign: 'start', border: "thin solid black", margin: "40px 20px", padding: "25px" }} >
                <MDBCol >
                    <h6 className="fw-bold">Proveedor:</h6> 
                    <p>  { printData?.proveedorLabel } </p>
                </MDBCol>
            </MDBRow> 
            <MDBRow style={{ margin: "40px 20px" }}>
                <MDBCol style={{ textAlign: 'start' }} > 
                    <h6 className="fw-bold">Productos y Servicios</h6>
                </MDBCol>
                { 
                    showItem([printData])
                }
            </MDBRow> 
            <MDBRow style={{ margin: "0 20px", textAlign: 'start' }}>
                <MDBCol style={{ marginTop: "20px" }}>
                  <h6 className="fw-bold" >Contacto</h6>
                  <p>{user?.name || ""}</p>
                  <p>{user?.correo || ""}</p>
                  <p>+52 {formatPhone(user?.telefono) || ""}</p>
                  <p>Medios Digitales Enfocados SAPI de CV </p>
                  <p>Blvd Gustavo Díaz Ordaz #12415 </p>
                  <p>Col El Paraiso </p>
                  <p>Tijuana, Baja California 22106 </p>
                  <p>México</p>
                </MDBCol>
            </MDBRow>         
        </StyledComponent>
    )
}

export default ComponentToPrint;
